<template>
  <div >
    <b-modal v-model="modal.ver" size="xl" title="Crear producto" hide-footer scrollable centered>
      <loader v-if="modal.loader"></loader>
      <el-steps class="mb-4" align-center :active="modal.paso" finish-status="success" process-status="process">
        <el-step title="Paso 1" description="Información general"></el-step>
        <el-step title="Paso 2" description="Componentes"></el-step>
        <el-step title="Paso 3" description="Cargar adjunto"></el-step>
        <el-step title="Paso 4" description="SGA"></el-step>
        <el-step title="Paso 5" description="Iconos Epp"></el-step>
        <el-step title="Paso 6" description="Empresas"></el-step>
        <el-step title="Paso 7" description="Ubicaciones"></el-step>
      </el-steps>
      <general v-if="modal.paso === 0"></general>
      <components v-if="modal.paso === 1"></components>
      <adjunto v-if="modal.paso === 2"></adjunto>
      <sga v-if="modal.paso === 3"></sga>
      <epp v-if="modal.paso === 4"></epp>
      <empresas v-if="modal.paso === 5"></empresas>
      <ubicaciones v-if="modal.paso === 6"></ubicaciones>
    </b-modal>
  </div>
</template>

<script>
  import general from "./general"
  import components from "./components"
  import adjunto from "./adjunto"
  import sga from './sga'
  import epp from "./epp"
  import empresas from "./empresas"
  import ubicaciones from "./ubicaciones"

  import {mapState} from "vuex"
  import loader from "../../../containers/loader"

  export default {
    name: "modal",
    components: {
      general,
      components,
      adjunto,
      sga,
      epp,
      empresas,
      ubicaciones,
      loader
    },
    computed: {
      ...mapState('pasoapaso', ['modal'])
    }
  }
</script>
